const AssetDiscriminator = Object.freeze({
  CODE: "CODE",
});

export default AssetDiscriminator;
